export default __webpack_public_path__ + "df4b406baa298a13a5359bf5eac96694.glb";